<template>
    <v-card variant="tonal" :border="true" class="text-center pa-3 elevation-2" :flat="true" :rounded="true">
        <v-btn color="black"
               :icon="true"
               size="large"
               variant="flat"
               :ripple="false"
               class="non-interactive"
               :style="{ border: '1px solid ' + (characterColorCss || 'rgba(var(--v-border-color))') }"
        >
            <v-icon :icon="'ko:character-' + character.name.toLowerCase()"
                   :color="characterColorCss"
                   size="30"
            />
        </v-btn>
        <div class="text-h6 mt-2">{{ quantity }}</div>
        <div class="currency-label text-medium-emphasis">{{ character.name }}</div>
    </v-card>
</template>

<script setup>
    import {computed} from "vue";
    import {storeToRefs} from "pinia";
    import {useMainStore} from "@/store";
    import {useCharacterColor} from "@/composables/useCharacterColor";

    const props = defineProps({
        quantity: {
            type: [Number, String],
        },
        character_id: {
            type: [Number, String],
        },
    });

    const store = useMainStore();
    const {references} = storeToRefs(store);
    const {getCharacterColorCss} = useCharacterColor();
    const characters = computed(() => references.value.data.design.character);

    const character = computed(() => {
        return characters.value.find(c => String(c.id) === String(props.character_id));
    });

    const characterColorCss = computed(() => getCharacterColorCss(character.value?.name));
</script>

<style scoped>
    .non-interactive {
        pointer-events: none;
    }
    .currency-label {
        font-size: 0.65rem;
        overflow-wrap: normal;
        word-break: keep-all;
        white-space: nowrap;
    }
</style>
